import { render } from "./PatientCreateUnderlyingDiseases.vue?vue&type=template&id=c85c094c&scoped=true"
import script from "./PatientCreateUnderlyingDiseases.vue?vue&type=script&lang=js"
export * from "./PatientCreateUnderlyingDiseases.vue?vue&type=script&lang=js"

import "./PatientCreateUnderlyingDiseases.vue?vue&type=style&index=0&id=c85c094c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85c094c"]])

export default __exports__